<template>
    <v-menu
        v-model="menuDate"
        :close-on-content-click="false"
        :nudge-right="getNudgeRight()"
        offset-y
        transition="scale-transition"
        min-width="290px"
        readonly
        >
        <template v-slot:activator="{ on }">
            <v-text-field
                ref="textfield"
                :class="[icon !== '' ? 'picker' : '', `${fontsize}`]"
                :value="dateValue"
                :label="label"
                :readonly="!manual"
                :hint="hint"
                :placeholder="placeholder"
                :error-messages="errorMessages"
                :prepend-icon="icon"
                :dense="isDense"
                :clearable="isClearable"
                v-on:click="onClick($event)"
                v-on:keydown="onKeydown($event)"
                v-on:focus="onFocus($event)"
                v-on:change="onChange($event)"
                v-on:click:clear="onClear()"
                v-on:blur="onBlur($event)"
                v-on="on">
            </v-text-field>
        </template>
        <v-date-picker :first-day-of-week="1" @input="updateData" :show-current="syncDate" :picker-date.sync="syncDate" elevation="10" ></v-date-picker>
    </v-menu>
</template>

<script>
export default {
    props: {
        datum: {
            type: String,
            required: true
        },
        field: {
            type: String,
            required: true
        },
        label: {
            type: String,
            required: false,
            default: ''
        },
        hint: {
            type: String,
            required: false,
            default: ''
        },
        placeholder: {
            type: String,
            required: false,
            default: ''
        },
        manual: {
            type: Boolean,
            required: false,
            default: true
        },
        fontsize: {
            type: String,
            required: false,
            default: ''
        },
        icon: {
            type: String,
            required: false,
            default: ''
        },
        isDense:{
          type: Boolean,
          required: false,
          default: true
        },
        startDate:{
            type: String,
            required: false,
            default: new Date().toISOString().substring(0, 10),
        },
        isClearable:{
            type: Boolean,
            required: false,
            default: true
        }
    },
    data() {
        return {
            menuDate: false,
            errorMessages: [],
            syncDate: ''
        }
    },
    computed: {
        dateValue() { // convert iso-dat to dmy before displaying
            return typeof this.datum === 'undefined' || this.datum === null || this.datum === '' ? '' : this.$moment(this.datum).format('DD-MM-YYYY');
        },
    },
    mounted() {
        this.syncDate = this.getStartDate(); // iso-date
    },
    methods: {
        getStartDate(){
            //console.log('startdate', this.startDate, this.dateValue)
            if(typeof this.startDate === 'undefined' || this.startDate === null || this.startDate === ''){
                if (this.dateValue!=='' ){
                    let items = this.dateValue.split('-') // display date = dmy
                    return `${items[2]}-${items[1]}-${items[0]}` // convert to iso-date
                } else {
                    return new Date().toISOString().substring(0, 10) // iso-date
                }
            } else{
                if (this.dateValue!=='' ){
                    let items = this.dateValue.split('-') // display date = dmy
                    return `${items[2]}-${items[1]}-${items[0]}` // convert to iso-date
                }
                return this.startDate // iso-date
            }
        },
        expandDate(dateString){
            let items = dateString.split('-') // display date = dmy
            let ok = true
            if (items.length !== 3) {
                ok = false;
            }
            if (ok) {
                ok = !(isNaN(items[0]) || isNaN(items[1]) || isNaN(items[2]));
            }
            if (ok) {
                if (items[0].length  === 1)  {
                    items[0] = '0' + items[0];
                }
                if (items[1].length  === 1)  {
                    items[1] = '0' + items[1];
                }
                if (items[2].length  === 2)  {
                    if (parseInt(items[2]) > 40) {
                        items[2] = '19' + items[2];
                    } else {
                        items[2] = '20' + items[2];
                    }
                }
            }
            if (ok) {
                ok = (items[0].length  === 2) && (items[1].length  === 2) && (items[2].length  === 4);
            }
            if (ok) {
                return items.join('-');
            }
            return "";
        },
        onClick() {
            this.syncDate = this.getStartDate()
            //console.log('syncdate', this.syncDate)
            //console.log('click', evt);
            this.errorMessages = [];
        },
        onClear(){
            // console.log('clear');
            this.errorMessages = []; // clear error on clear
            this.$emit('updateData', { "field": this.field, "value": null }); // always emit null value or the textfield will not be updated correctly
        },
        onBlur(evt){
           //console.log('blur', evt.target.value, this.menuDate===false);
           //this.menuDate=false
           if (this.menuDate===false) {
                let testDate = this.expandDate(evt.target.value);
                if (testDate !== "") {
                    this.checkInput(testDate);
                }
           }
        },
        onFocus(evt) {
            if(this.menuDate===false && this.manual===true){
                try {
                    evt.target.select();
                } catch (err) {
                    return;
                }
            }
        },
        onChange(v){
            // console.log('change', v);
            if(this.manual){
                if(String(v).length===10){
                    this.checkInput(v)
                }
            }
        },
        checkInput(v){
            // force format 99-99-9999 for display (not 99/99/9999)
            // console.log('blur', evt.target.value);

            const date_regex = /^(?:(?:31(-)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(-)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(-)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(-)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/;
            // const date_regex = /^(0?[1-9]|[12][0-9]|3[01])[\u002D\u2212](0?[1-9]|1[0-2])[\u002D\u2212]\d{4}$/;

            if(v === '' || v === null){
                this.errorMessages = [];
            } else {
                v = v.replace(/\u2212/g, '-'); // allow both '-' and \u2212 as separator for manual input
                // if (!date_regex.test(v) || String(v).length!==10) {
                //     this.errorMessages.push('Invalid date, correct format = dd-mm-yyyy');
                //     this.$refs.textfield.focus();
                // } else {
                //     this.errorMessages = []; // clear any errors after successful validation
                //     this.updateData(v);
                // }
                if (!date_regex.test(v)) {
                    this.errorMessages.push('Invalid date, correct format = dd-mm-yyyy');
                    this.$refs.textfield.focus();
                    return;
                }
                let tempDate = this.expandDate(v);
                if (tempDate === "") {
                    this.errorMessages.push('Invalid date, correct format = dd-mm-yyyy');
                    this.$refs.textfield.focus();
                    return;
                }

                this.errorMessages = []; // clear any errors after successful validation
                this.updateData(tempDate);
            }
        },

        onKeydown(e) {

            // console.log('change', e);
            // console.log('keydown', e.key, e.keyCode, e.shiftKey, e.ctrlKey);

            let allowedalphakeys = [8, 9, 46, 35, 36, 37, 39]; // backspace, tab, delete, home, end, left, right
            let allowedctrlkeys = [65, 67, 88, 86]; // ctrl-a, ctrl-c, ctrl-v, ctrl-x
            let allowednumpadkeys = [109, 173]; // '-' of numpad and regular keyboard
            let isUnicodeMinus = e.key === '\u2212'; // '−'

            if (!(
                ((e.keyCode >= 48 && e.keyCode <= 57) && !e.shiftKey)
                || (e.keyCode == 189 && !e.shiftKey)
                || (e.keyCode >= 96 && e.keyCode <= 105)
                || allowedalphakeys.includes(e.keyCode)
                || (allowedctrlkeys.includes(e.keyCode) && e.ctrlKey)
                || (allowednumpadkeys.includes(e.keyCode))
                || isUnicodeMinus
            )) {
                console.log('Blocked key:', e.key, e.keyCode);
                e.preventDefault();
            } else {
                this.errorMessages = []; // clear any errors when typing
            }

        },
        getNudgeRight(){
            return this.pickerprependicon === '' ? 40 : 60;
        },
        updateData(data) {
            // console.log('update', data);
            // manually entered format = dd-mm-yyyy, via picker format = yyyy-mm-dd.
            // check format and convert dmy --> iso if needed
            const isodate_regex = /^\d{4}-([0]\d|1[0-2])-([0-2]\d|3[01])$/;
            !isodate_regex.test(data) ? data = data.split("-").reverse().join("-") : data; //  create an array of the dmy date, reverse it and join it again using the 'dash'...
            this.menuDate=false; // make sure the picker is unloaded
            this.$emit('updateData', { "field": this.field, "value": data }); // always emit iso-date
        }
    }
}
</script>

<style scoped>
    .picker {
        min-width: 145px !important;
    }
    .medium {
	font-size: medium !important;
    }
    .small {
	font-size: small !important;
    }
    .medium {
	font-size: medium !important;
    }
    .large {
	font-size: large !important;
    }

</style>